// Generic service-state API-helper.
// Skapar getAllState/getState/patchState/putState/removeState för en
// /api/<service>/state-endpoint. Används av customerrisk, georisk, txmon,
// pr, external-models, approval, compliance — alla med samma backend-
// route-mönster (createServiceStateRouter på server-sidan).

import { http } from './httpClient';

export function createServiceStateApi(servicePath) {
  const base = `/${servicePath}`;
  return {
    getAllState: async (opts = {}) => {
      const r = await http.get(`${base}/state`, opts);
      return r.data || {};
    },
    getState: async (key, opts = {}) => {
      const r = await http.get(`${base}/state/${encodeURIComponent(key)}`, opts);
      return r.data;
    },
    patchState: async (patch, opts = {}) => {
      const r = await http.patch(`${base}/state`, patch, opts);
      return r.data || {};
    },
    putState: async (key, value, opts = {}) => {
      const r = await http.put(`${base}/state/${encodeURIComponent(key)}`, value, opts);
      return r.data;
    },
    removeState: async (key, opts = {}) => {
      await http.delete(`${base}/state/${encodeURIComponent(key)}`, opts);
    },
  };
}
